export const UNKNOWN_CHANNEL = 'unknown';
export const DASHBOARD_CHANNEL = 'dashboard';
export const GOODWILL_FUNNEL_CHANNEL = 'goodwill_funnel';
export const JOURNEY_DETAILS_PAGE_UPGRADE = 'journey_details_page_upgrade';
export const TRIP_ACTIVATION = 'trip_activation';
export const BANNER_CHANNEL = 'banner_complete';
export const BANNER_CHANNEL_PRO = 'banner_pro';
export const ESSENTIAL_TO_SMART_UPGRADE = 'essential_smart_lp';
